var exports = {
  "P": "NewRulesetButton__j5g4qT",
};

module.exports = exports;
